var floatingPanel = null;
var floatingPanelSource = null;
var outsideClickBound = false;
var escapeKeyBound = false;
var urlChangeBound = false;

function theaLauncherHide() {
  var el = document.getElementById('thea-skin-analysis-launcher');
  if (el) el.classList.add('hidden');
  var kl = document.querySelector('.kl-teaser-Xd2YWs');
  if (kl) kl.classList.add('hidden');
}
function theaLauncherShow() {
  // Don't restore while the mobile filter drawer is still open
  if (document.querySelector('html').style.overflowY === 'hidden') return;
  var el = document.getElementById('thea-skin-analysis-launcher');
  if (el) el.classList.remove('hidden');
  var kl = document.querySelector('.kl-teaser-Xd2YWs');
  if (kl) kl.classList.remove('hidden');
}

document.addEventListener('DOMContentLoaded', function () {
  initDesktopFacets();
  initMobileFacets();
});

/* ============================================================
   DESKTOP — HORIZONTAL FILTER BAR
   ============================================================ */

function initDesktopFacets() {
  floatingPanel = null;
  floatingPanelSource = null;
  initFilterDropdowns();
  initSortDropdown();
  initPriceSliders();
  initOutsideClick();
  initEscapeKey();
  initClearButton();
  onUrlChange();
  enableFacetInputs();
}

function initClearButton() {
  document.querySelectorAll('.facets-bar__clear-all').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();

      returnFloatingContent();
      if (floatingPanel) floatingPanel.hidden = true;
      getAllFilterTriggers().forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });

      var clearUrl = btn.getAttribute('href') || window.location.pathname;

      // Dawn v3: FacetFiltersForm exposes a static renderPage on the custom element constructor
      var facetEl = document.querySelector('facet-filters-form');
      var FacetClass = facetEl && facetEl.constructor;
      if (FacetClass && typeof FacetClass.renderPage === 'function') {
        FacetClass.renderPage('', null, true);
        return;
      }

      // Fallback: fetch the clear URL and swap product grid + facets sections
      history.pushState({}, '', clearUrl);
      fetch(clearUrl)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var newDoc = parser.parseFromString(html, 'text/html');

          var swapSelectors = [
            '#ProductGridContainer',
            '#product-grid',
            '.product-grid-container',
            '[data-section-type="collection-template"]'
          ];
          swapSelectors.forEach(function (sel) {
            var newEl = newDoc.querySelector(sel);
            var curEl = document.querySelector(sel);
            if (newEl && curEl) curEl.innerHTML = newEl.innerHTML;
          });

          // Refresh the filter bar to clear active states
          var newFilters = newDoc.getElementById('main-collection-filters');
          var curFilters = document.getElementById('main-collection-filters');
          if (newFilters && curFilters) {
            curFilters.innerHTML = newFilters.innerHTML;
            initDesktopFacets();
          }
        })
        .catch(function () {
          window.location = clearUrl;
        });
    });
  });
}

function getAllFilterTriggers() {
  return document.querySelectorAll('[data-facet-trigger]');
}

function getAllFilterPanels() {
  return document.querySelectorAll('[data-facet-panel]');
}

function closeAllFilterPanels() {
  getAllFilterTriggers().forEach(function (trigger) {
    trigger.setAttribute('aria-expanded', 'false');
  });
  getAllFilterPanels().forEach(function (panel) {
    panel.hidden = true;
  });
  returnFloatingContent();
  if (floatingPanel) floatingPanel.hidden = true;
  theaLauncherShow();
}

function createFloatingPanel() {
  if (floatingPanel) return;
  var form = document.getElementById('FacetFiltersForm');
  if (!form) return;
  floatingPanel = document.createElement('div');
  floatingPanel.className = 'facets-bar__floating-panel';
  floatingPanel.hidden = true;
  form.appendChild(floatingPanel);
}

function returnFloatingContent() {
  if (!floatingPanel || !floatingPanelSource) return;
  var inner = floatingPanel.firstElementChild;
  if (inner) floatingPanelSource.appendChild(inner);
  floatingPanelSource = null;
}

function positionFloatingPanel(trigger) {
  if (!floatingPanel) return;
  var bar = document.querySelector('.facets-bar');
  if (!bar) return;
  var barRect = bar.getBoundingClientRect();
  var trigRect = trigger.getBoundingClientRect();
  floatingPanel.style.left = (trigRect.left - barRect.left + trigRect.width / 2) + 'px';
  floatingPanel.style.top = (barRect.height + 26) + 'px';
}

function closeSortPanel() {
  const trigger = document.querySelector('[data-sort-trigger]');
  const panel = document.querySelector('[data-sort-panel]');
  if (trigger) trigger.setAttribute('aria-expanded', 'false');
  if (panel) panel.hidden = true;
  theaLauncherShow();
}

function initFilterDropdowns() {
  createFloatingPanel();

  getAllFilterTriggers().forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var index = trigger.dataset.facetTrigger;
      var sourcePanel = document.querySelector('[data-facet-panel="' + index + '"]');
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      var isVisible = floatingPanel && !floatingPanel.hidden;

      closeSortPanel();

      if (isOpen) {
        trigger.setAttribute('aria-expanded', 'false');
        returnFloatingContent();
        if (floatingPanel) floatingPanel.hidden = true;
        return;
      }

      getAllFilterTriggers().forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
      });
      trigger.setAttribute('aria-expanded', 'true');

      var inner = sourcePanel ? sourcePanel.querySelector('.facets-bar__panel-inner') : null;
      if (!inner || !floatingPanel) return;

      if (isVisible) {
        // Switching panels: slide to new position while crossfading content
        floatingPanel.classList.add('is-switching');
        positionFloatingPanel(trigger);
        var capturedInner = inner;
        var capturedSource = sourcePanel;
        setTimeout(function () {
          returnFloatingContent();
          floatingPanel.appendChild(capturedInner);
          floatingPanelSource = capturedSource;
          floatingPanel.classList.remove('is-switching');
        }, 150);
      } else {
        // Fresh open
        floatingPanel.appendChild(inner);
        floatingPanelSource = sourcePanel;
        positionFloatingPanel(trigger);
        floatingPanel.hidden = false;
      }
    });
  });
}

function initSortDropdown() {
  const trigger = document.querySelector('[data-sort-trigger]');
  const panel = document.querySelector('[data-sort-panel]');
  if (!trigger || !panel) return;

  trigger.addEventListener('click', function () {
    const isOpen = trigger.getAttribute('aria-expanded') === 'true';
    closeAllFilterPanels();
    closeSortPanel();

    if (!isOpen) {
      trigger.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      theaLauncherHide();
    }
  });

  // Close and update label after sort selection
  panel.querySelectorAll('input[type="radio"]').forEach(function (radio) {
    radio.addEventListener('change', function () {
      const label = document.querySelector('[data-sort-label]');
      if (label) {
        const optionLabel = radio.closest('.facets-bar__sort-option').querySelector('.facets-bar__item-label');
        if (optionLabel) label.textContent = optionLabel.textContent.trim();
      }
      closeSortPanel();
    });
  });
}

function initOutsideClick() {
  if (outsideClickBound) return;
  outsideClickBound = true;
  document.addEventListener('click', function (event) {
    if (event.target.closest('.facets-bar')) return;
    closeAllFilterPanels();
    closeSortPanel();
  });
}

function initEscapeKey() {
  if (escapeKeyBound) return;
  escapeKeyBound = true;
  document.addEventListener('keyup', function (event) {
    if (event.key === 'Escape') {
      closeAllFilterPanels();
      closeSortPanel();
    }
  });
}

/* ============================================================
   PRICE RANGE SLIDER
   ============================================================ */

function initPriceSliders() {
  document.querySelectorAll('[data-price-slider]').forEach(function (slider) {
    const panelInner = slider.closest('.facets-bar__panel-inner--price');
    if (!panelInner) return;

    const rangeMin = slider.querySelector('[data-range-min]');
    const rangeMax = slider.querySelector('[data-range-max]');
    const fill = slider.querySelector('[data-price-fill]');

    const numMin = panelInner.querySelector('[data-price-number-min]');
    const numMax = panelInner.querySelector('[data-price-number-max]');
    const displayMin = panelInner.querySelector('[data-price-min-display]');
    const displayMax = panelInner.querySelector('[data-price-max-display]');

    if (!rangeMin || !rangeMax) return;

    function updateFill() {
      const total = parseFloat(rangeMin.max) || 1;
      const minPct = (parseFloat(rangeMin.value) / total) * 100;
      const maxPct = (parseFloat(rangeMax.value) / total) * 100;
      if (fill) {
        fill.style.left = minPct + '%';
        fill.style.right = (100 - maxPct) + '%';
      }
    }

    function formatMoney(cents) {
      const dollars = (cents / 100).toFixed(2);
      return '$' + dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function syncFromRanges() {
      const minVal = parseFloat(rangeMin.value);
      const maxVal = parseFloat(rangeMax.value);

      // Prevent handles from crossing
      if (minVal > maxVal) {
        rangeMin.value = maxVal;
      }

      const currentMin = parseFloat(rangeMin.value);
      const currentMax = parseFloat(rangeMax.value);

      // Update hidden number inputs (these get submitted in FormData)
      if (numMin) {
        numMin.value = currentMin === 0 ? '' : currentMin;
      }
      if (numMax) {
        const rangeMaxAttr = parseFloat(rangeMax.max);
        numMax.value = currentMax >= rangeMaxAttr ? '' : currentMax;
      }

      // Update displayed price values
      if (displayMin) displayMin.textContent = formatMoney(currentMin * 100);
      if (displayMax) displayMax.textContent = formatMoney(currentMax * 100);

      updateFill();
    }

    rangeMin.addEventListener('input', function () {
      if (parseFloat(rangeMin.value) > parseFloat(rangeMax.value)) {
        rangeMin.value = rangeMax.value;
      }
      syncFromRanges();
    });

    rangeMax.addEventListener('input', function () {
      if (parseFloat(rangeMax.value) < parseFloat(rangeMin.value)) {
        rangeMax.value = rangeMin.value;
      }
      syncFromRanges();
    });

    // Trigger form submission after slider interaction ends
    rangeMin.addEventListener('change', function () {
      if (numMin) numMin.dispatchEvent(new Event('change', { bubbles: true }));
    });

    rangeMax.addEventListener('change', function () {
      if (numMax) numMax.dispatchEvent(new Event('change', { bubbles: true }));
    });

    // Initialise fill position
    updateFill();
  });
}

/* ============================================================
   MOBILE — unchanged behaviour
   ============================================================ */

function initMobileFacets() {
  enableMobileFacetInputs();
  bindMobileFacetsEvents();
  bindFacetsEvents();
  observeUrlChange();
  updateClearButtonVisibility();
  bindFacetCheckboxListeners();
  bindSlideFilterButtonListeners();
}

function enableFacetInputs() {
  document.querySelectorAll('.facets__item input').forEach(function (input) {
    input.removeAttribute('disabled');
  });
}

function enableMobileFacetInputs() {
  document.querySelectorAll('.mobile-facets__item input').forEach(function (input) {
    input.removeAttribute('disabled');
  });
}

function bindMobileFacetsEvents() {
  document.querySelectorAll('.mobile-facets__item input').forEach(function (input) {
    input.addEventListener('change', handleMobileFacetChange);
  });
}

function handleMobileFacetChange(e) {
  const input = e.target;
  const valuez = (input.getAttribute('value') || '').trim();
  if (!valuez) return;
  document.querySelectorAll('.mobile-facets__item input').forEach(function (el) {
    const datas = el.getAttribute('value') || '';
    if (datas.indexOf(',') < 0) return;
    const parts = datas.split(',').map(function (s) { return s.trim(); });
    if (parts.indexOf(valuez) < 0) return;
    if (input.checked) {
      el.checked = true;
      el.classList.add('hide-before');
    } else {
      el.checked = false;
      el.classList.remove('hide-before');
    }
  });
}

function bindFacetsEvents() {
  document.querySelectorAll('.facets__item input').forEach(function (input) {
    input.addEventListener('change', handleFacetChange);
    input.addEventListener('click', handleFacetChange);
  });
}

function handleFacetChange(e) {
  const input = e.target;
  const valuez = input.getAttribute('value');
  if (input.checked) {
    document.querySelectorAll('.facets__item input').forEach(function (el) {
      const datas = el.getAttribute('value');
      if (datas && datas.indexOf(',') >= 0 && datas.indexOf(valuez) >= 0) {
        el.checked = true;
        el.classList.add('hide-before');
      }
    });
  } else {
    document.querySelectorAll('.facets__item input').forEach(function (el) {
      const datas = el.getAttribute('value');
      if (datas && datas.indexOf(valuez) >= 0) {
        el.checked = false;
        el.classList.remove('hide-before');
      }
    });
  }
}

function observeUrlChange() {
  if (urlChangeBound) return;
  urlChangeBound = true;
  let lastUrl = location.href;
  if (lastUrl.indexOf('/collections/') >= 0) {
    new MutationObserver(function () {
      const url = location.href;
      if (url !== lastUrl) {
        lastUrl = url;
        onUrlChange();
      }
    }).observe(document, { subtree: true, childList: true });
  }
}

function onUrlChange() {
  const url = location.href;
  const res = url.split('&');
  let foo = 0;
  for (let i = 0; i < res.length; i++) {
    if (res[i].indexOf('concerns') >= 0 || res[i].indexOf('price') >= 0) {
      if (res[i].indexOf('%2C') <= 0) {
        const final = res[i].split('=');
        let NewFinal = decodeURIComponent(final[1]);
        NewFinal = NewFinal.replace(/\+/g, ' ');
        document.querySelectorAll('.unique_labels input').forEach(function (input) {
          if (input.getAttribute('value') && input.getAttribute('value').trim() === NewFinal.trim()) {
            input.checked = true;
          }
        });
        document.querySelectorAll('.facets__item input').forEach(function (input) {
          if (input.getAttribute('value') && input.getAttribute('value').trim() === NewFinal.trim()) {
            input.checked = true;
          }
        });
      }
    }
  }
  let xpp = 0;
  document.querySelectorAll('.product_filter input').forEach(function (input) {
    if (input.checked) xpp++;
  });
  document.querySelectorAll('.unique_labels input').forEach(function (input) {
    if (input.checked) foo++;
  });
  xpp = xpp / 2;
  foo = foo / 2;
  const counterPlace = document.querySelector('.counter_place');
  if (counterPlace) counterPlace.textContent = foo + xpp;
}

function updateClearButtonVisibility() {
  const clearButtons = document.querySelectorAll('.clear_button');
  const facetCheckboxes = document.querySelectorAll('.facets__item input[type="checkbox"]');
  const anyChecked = Array.from(facetCheckboxes).some(function (cb) { return cb.checked; });
  clearButtons.forEach(function (button) {
    button.classList.toggle('hidden', !anyChecked);
  });
}

function bindFacetCheckboxListeners() {
  document.querySelectorAll('.facets__item input[type="checkbox"]').forEach(function (checkbox) {
    checkbox.addEventListener('change', updateClearButtonVisibility);
  });
}

function bindSlideFilterButtonListeners() {
  document.querySelectorAll('.js-button__slide-filter').forEach(function (button) {
    if (button.getAttribute('listener') !== 'true') {
      button.setAttribute('listener', 'true');
      button.addEventListener('click', function () {
        var slidemenu = button.parentNode;
        if (!slidemenu) return;
        var scope = button.closest('.mobile-facets__wrapper') || document;
        var isOpen = slidemenu.hasAttribute('open');
        scope.querySelectorAll('.mobile-facets__slidemenu').forEach(function (menu) {
          menu.removeAttribute('open');
        });
        if (!isOpen) {
          slidemenu.setAttribute('open', '');
        }
      });
    }
  });
}
